import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Lock, Mail, Loader2, Mic } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { ADMIN } from "@/constants/testIds";

const AdminLogin = () => {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);

  if (user && user !== false) return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr(null);
    setBusy(true);
    const res = await login(email, password);
    setBusy(false);
    if (res.ok) navigate("/admin");
    else setErr(res.error);
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center p-4"
      style={{
        background:
          "linear-gradient(135deg, #0D1B4B 0%, #1a2960 55%, #0D1B4B 100%)",
      }}
    >
      <div className="absolute -top-32 -right-32 w-96 h-96 rounded-full fi-gradient opacity-25 blur-3xl pointer-events-none" />
      <div className="w-full max-w-sm bg-white rounded-2xl p-6 sm:p-8 shadow-2xl relative">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-11 h-11 rounded-xl fi-gradient flex items-center justify-center">
            <div className="w-[38px] h-[38px] rounded-[10px] bg-[var(--fi-blue)] flex items-center justify-center">
              <Mic className="w-5 h-5 text-white" strokeWidth={2.4} />
            </div>
          </div>
          <div>
            <div className="font-display text-xl font-extrabold uppercase text-[var(--fi-blue)] leading-none">
              Fala Itapira
            </div>
            <div className="text-[10px] tracking-[0.28em] uppercase text-gray-400 font-bold">
              Painel Administrativo
            </div>
          </div>
        </div>

        <h1 className="font-display text-3xl font-black uppercase text-[var(--fi-blue)] leading-tight">
          Entrar
        </h1>
        <p className="text-sm text-gray-500 mt-1">
          Acesso restrito à equipe da redação.
        </p>

        <form onSubmit={onSubmit} className="mt-6 space-y-4">
          <label className="block">
            <span className="text-xs uppercase tracking-widest font-bold text-[var(--fi-blue)]">
              E-mail
            </span>
            <div className="relative mt-1.5">
              <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
              <input
                data-testid={ADMIN.loginEmail}
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoFocus
                required
                className="w-full pl-9 pr-3 py-2.5 border border-gray-200 rounded-xl text-sm outline-none focus:border-[var(--fi-blue)] transition-colors"
                placeholder="admin@falaitapira.com.br"
              />
            </div>
          </label>
          <label className="block">
            <span className="text-xs uppercase tracking-widest font-bold text-[var(--fi-blue)]">
              Senha
            </span>
            <div className="relative mt-1.5">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
              <input
                data-testid={ADMIN.loginPassword}
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="w-full pl-9 pr-3 py-2.5 border border-gray-200 rounded-xl text-sm outline-none focus:border-[var(--fi-blue)] transition-colors"
                placeholder="••••••••"
              />
            </div>
          </label>
          {err && (
            <div
              data-testid={ADMIN.loginError}
              className="text-sm text-[var(--fi-red)] bg-red-50 border border-red-100 rounded-lg px-3 py-2"
            >
              {err}
            </div>
          )}
          <button
            data-testid={ADMIN.loginSubmit}
            disabled={busy}
            type="submit"
            className="w-full inline-flex items-center justify-center gap-2 rounded-xl bg-[var(--fi-red)] hover:bg-[var(--fi-red-hover)] text-white font-bold uppercase tracking-widest text-sm py-3 transition-colors disabled:opacity-70"
          >
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Entrar"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
